import { Company } from '../types/company.types';
import { AccessRole } from '../types/stakeholder.types';

export const syncStakeholderDocumentPermission = (company: Company | null | undefined): void => {
  if (company?.stakeholder?.accessRole === AccessRole.AUDITOR) {
    document.documentElement.setAttribute('data-permission', 'denied');
    return;
  }

  document.documentElement.removeAttribute('data-permission');
};
